import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import Toast from '../../helpers/Toast';
import { GetMaintenancePlanAuditDTO } from '../../models/MaintenancePlan/GetMaintenancePlanAuditDTO';
import { MaintenancePlanService } from '../../services/MaintenancePlanService';
import ButtonComponent from '../ButtonComponent';
import TableComponent from '../TableComponent';

export type MaintenancePlanAuditTableComponentProps = {
    OnCancel: () => void;
    IsOpen: boolean;
    MaintenancePlanId: string | null | undefined;
}

export default function MaintenancePlanAuditTableComponent(props: MaintenancePlanAuditTableComponentProps) {
    const intl = useIntl();
    const maintenancePlanService = new MaintenancePlanService();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [data, setData] = useState<GetMaintenancePlanAuditDTO[]>([]);

    useEffect(() => {
        if (props.IsOpen === true) {
            GetMaintenancePlanAudit();
        }
    }, [props.IsOpen]);

    const GetMaintenancePlanAudit = async () => {
        setIsLoading(true);
        const response = await maintenancePlanService.GetMaintenancePlanAudit(Number(props.MaintenancePlanId));

        if (response.success !== true) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }
        setData(response.obj ? [response.obj] : []); // só tem um registo para já e componente table precisa de array
        setIsLoading(false);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: <FormattedMessage id="MaintenancePlanAuditTableComponent.Table.User" />,
                accessor: "userName",
                width: 60,
            },
            {
                Header: <FormattedMessage id="MaintenancePlanAuditTableComponent.Table.Date" />,
                accessor: "date",
                width: 40,
            }
        ],
        []
    );

    return (
        <Dialog open={props.IsOpen} fullWidth={true} maxWidth="xs">
            <DialogTitle textAlign={'center'}>
                {intl.formatMessage({ id: "MaintenancePlanAuditTableComponent.Title" })}
            </DialogTitle>
            <DialogContent>
                <div className="pageComponent" style={{ width: "100%" }}>
                    <TableComponent
                        goToPage={1}
                        loading={isLoading}
                        pageCount={1}
                        columns={columns}
                        manualPagination={true}
                        fetchData={GetMaintenancePlanAudit}
                        pageSizes={[1]}
                        initialPage={1}
                        initialPageSize={1}
                        initialSortBy={[]}
                        data={data}
                        dontOrderFirstCollumn={true}
                    />
                </div>
            </DialogContent>

            <DialogActions className="loginbuttons">
                <ButtonComponent
                    onClick={props.OnCancel}
                    className="enteraccount"
                    style={{ width: "100%", borderRadius: "5px", margin: "20px" }}
                    text={intl.formatMessage({ id: "MaintenancePlanAuditTableComponent.Button.Cancel" })}
                    loading={isLoading}
                />
            </DialogActions>
        </Dialog>
    );
}